module.exports = __webpack_public_path__ + "img/logo-canada-mapple-only.e74e086d.svg";